import { CarouselStyledItem } from 'components/storybook-migration/Carousel/Carousel.styled';
import { CarouselProps } from 'components/storybook-migration/Carousel/Carousel.types';
import React from 'react';

const CarouselItem = ({ children, ...props }: CarouselProps) => {
  return <CarouselStyledItem {...props}>{children}</CarouselStyledItem>;
};

export default CarouselItem;
